import { arrayOfType } from '../../utils/util-functions';
import { IStatementChallenge, StatementChallengeModel } from './challenge.model';

export interface IScoreCardSection {
  sectionName: string;
  statements: IStatement[];
}

export interface IStatement {
  id: number;
  text: string;
  displayName: string;
  evaluation: IStatementEvaluation;
  points: number | null;
  challenges: IStatementChallenge[];
  displayNameOrText: string;
  isHidden: boolean;
}

export interface IStatementEvaluation {
  modified: boolean;
  status: TStatementEvaluationStatus;
  justification: string;
  originalStatus: TStatementEvaluationStatus;
  originalJustification: string;
  naCriteria: string | null;
}

export type TStatementEvaluationStatus = 'success' | 'fail' | 'unknown' | 'error';

export class ScoreCardSectionModel implements IScoreCardSection {
  sectionName: string = '';
  statements: IStatement[] = [];

  constructor(data?: IScoreCardSection) {
    this.sectionName = data?.sectionName ?? this.sectionName;
    this.statements = arrayOfType<StatementModel>(data?.statements, StatementModel);
  }
}

export class StatementModel implements IStatement {
  id: number = 0;
  text: string = '';
  displayName: string = '';
  evaluation: IStatementEvaluation = {} as IStatementEvaluation;
  points: number | null = null;
  challenges: IStatementChallenge[];
  displayNameOrText: string = '';
  isHidden: boolean = false;

  constructor(data?: IStatement) {
    this.id = data?.id ?? this.id;
    this.text = data?.text ?? this.text;
    this.displayName = data?.displayName ?? this.displayName;
    this.points = data?.points ?? this.points;
    this.evaluation = new StatementEvaluationModel(data?.evaluation);
    this.challenges = arrayOfType<StatementChallengeModel>(data?.challenges, StatementChallengeModel);
    this.displayNameOrText = (data?.displayName || data?.text) ?? this.displayNameOrText;
    this.isHidden = data?.isHidden ?? this.isHidden;
  }
}

export class StatementEvaluationModel implements IStatementEvaluation {
  status: TStatementEvaluationStatus = 'unknown';
  modified: boolean = false;
  justification: string = '';
  originalStatus: TStatementEvaluationStatus = 'unknown';
  originalJustification: string = '';
  naCriteria: string | null = null;

  constructor(data?: IStatementEvaluation) {
    this.status = data?.status ?? this.status;
    this.modified = data?.modified ?? this.modified;
    this.justification = data?.justification ?? this.justification;
    this.originalStatus = data?.originalStatus ?? this.originalStatus;
    this.originalJustification = data?.originalJustification ?? this.originalJustification;
    this.naCriteria = data?.naCriteria ?? this.naCriteria;
  }
}
